import { FileTextOutlined, MailOutlined } from "@ant-design/icons";

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const support = {
  id: "support",
  type: "group",
  title: "Admin & Docs",
  children: [
    {
      id: "documentation",
      title: "Documentation",
      type: "item",
      url: "/documentation",
      icon: FileTextOutlined,
    },
    {
      id: "support",
      title: "Support",
      type: "support",
      icon: MailOutlined,
    },
  ],
};

export default support;
